import React from "react";

const TableGroupName = () => {
  return (
    <>
      <ol>
        <h4>List of 'groupName'</h4>
        <li>Jelly Belly Official Flavors</li>
        <li>Kids Mix Flavors</li>
        <li>Cold Stone® Flavors</li>
        <li>Sunkist® Citrus Mix Flavors</li>
        <li>Superfruit Flavors</li>
        <li>Sours Flavors</li>
        <li>Krispy Kreme® Doughnuts Flavors</li>
        <li>Soda Pop Shoppe® Flavors</li>
        <li>Sugar-Free Assorted Flavors</li>
        <li>Jewel Jelly Beans Flavors</li>
        <li>Snapple™ Mix Flavors</li>
        <li>Cocktail Classics® Flavors</li>
        <li>Tropical Mix Flavors</li>
        <li>Boba Milk Tea Flavors</li>
      </ol>
    </>
  );
};

export default TableGroupName;
